import { gql } from '__generated__';

export default gql(`
  mutation ConnectActiveCampaign($input: ConnectActiveCampaignInput!) {
    connectActiveCampaign(input: $input) {
      id
      ...Integrations
    }
  }
`);
